module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/union.6f1ac3a0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RatingCard/images/union.png
// module id = 3459
// module chunks = 11